module.exports = __webpack_public_path__ + "static/995ddad7.fourth-group-img.png";